<script setup>
defineProps({
  cashFlow: { type: Object, default: null },
  emptyMessage: { type: String, default: 'Дані відсутні' },
})

const money = (value) => value == null ? '—' : `${new Intl.NumberFormat('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)} грн`
</script>

<template>
  <section class="indicator-section" aria-labelledby="cash-heading">
    <h2 id="cash-heading"><span>02</span> Грошовий обіг</h2>
    <div v-if="cashFlow" class="dashboard-panel cash-panel">
      <div class="cash-totals">
        <article><small>Загальний обіг</small><strong>{{ money(cashFlow.totalTurnover) }}</strong></article>
        <article><small>Обіг готівки</small><strong>{{ money(cashFlow.cashTurnover) }}</strong></article>
        <article><small>Безготівковий обіг</small><strong>{{ money(cashFlow.nonCashTurnover) }}</strong></article>
      </div>
      <div class="table-wrap cash-table-wrap">
        <table class="cash-table"><thead><tr><th>Форма оплати</th><th>Оплати</th><th>Виплати</th><th>Службові внесення</th><th>Службові винесення</th><th>Обіг</th></tr></thead>
          <tbody><tr v-for="(row, index) in cashFlow.rows" :key="row.paymentFormId" :class="`cash-row-${index % 4}`"><th>{{ row.paymentFormName || `Форма №${row.paymentFormId}` }}</th><td>{{ money(row.payments) }}</td><td>{{ money(row.payouts) }}</td><td>{{ money(row.deposits) }}</td><td>{{ money(row.withdrawals) }}</td><td><strong>{{ money(row.turnover) }}</strong></td></tr></tbody>
          <tfoot><tr><th>Разом</th><td colspan="4"></td><td><strong>{{ money(cashFlow.totalTurnover) }}</strong></td></tr></tfoot>
        </table>
      </div>
    </div>
    <p v-else class="dashboard-panel section-unavailable">{{ emptyMessage }}</p>
  </section>
</template>
